import type { BulkComplianceUploaderResult } from '@xbcb/api-gateway-client';
import bulkUploadPageMaker from 'components/BulkUploadRequest';

const headers = [
  'identifierType',
  'identifier',
  'importEntryNumber',
  'movementReferenceNumber',
  'eoriNumber',
  'status',
  'failureReason',
];

const resultMapFunc = (result: BulkComplianceUploaderResult) => {
  const {
    identifier,
    identifierType,
    importEntryNumber,
    movementReferenceNumber,
    eoriNumber,
  } = result?.fields || {};
  return {
    identifier,
    identifierType,
    importEntryNumber,
    movementReferenceNumber,
    eoriNumber,
    status: result?.status,
    failureReason: result?.failureReason,
  };
};

const BulkComplianceUploadRequest = bulkUploadPageMaker({
  headers,
  resultMapFunc,
});

export default BulkComplianceUploadRequest;
